
import { quotesPrefix } from "./config";

export class ApiService {
  basePath = "";
  middleware = "";
  constructor(basePath, middleware = {}) {
    this.basePath = basePath;
    this.middleware = middleware;
  }

  // Generic request for all the endpoints
  async httpRequest(method, path, body, options = {}) {
    let response;
    try {
      let token = localStorage.getItem("User");

      response = await fetch(`${this.basePath}${path}`, {
        method,
        headers: {
          ...(options.multiPart ? {} : body ? { ["Content-Type"]: "application/json" } : {}),
          // ...(options.location ? {} : { Authorization: `Bearer ${token}` })
          ...{ Authorization: `Bearer ${token}` }
        },
        body: options.multiPart ? body : body ? JSON.stringify(body) : undefined
      });
    } catch (e) {
      if (e instanceof Error) {
        this.middleware.onError?.(e);
        return;
      }
    }

    // handle if error from API
    if (response && response.ok) {
      try {
        
        this.middleware.hideLoader();
        return await response.json();
      } catch (e) {
        if (e instanceof Error) {
          this.middleware.onError?.(e);
        }

        throw e;
      }
    } else {
      // handle all other errors
      await this.handleResponseError(response);
    }
    this.middleware.hideLoader();
    // Hide Loader
  }

  // Handle API response errors
  async handleResponseError(response) {
    let json;
    try {
      json = await response.json();
    } catch (e) {
      json = e;
    }
    
    this.middleware.onError?.(json);
    throw json;
  }

  // Post personal info
  postFormData(data, apiUrl, multiPart = false) {
    return this.httpRequest("POST", `puc/add-puc/${apiUrl}`, data, { multiPart });
  }
  // Post personal info
  // displayWallPostFormData(data, apiUrl, multiPart = false) {
  //   return this.httpRequest("POST", `${apiUrl}`, data, { multiPart });
  // }
  // Post Payment info
  postPaymentData(data, apiUrl, multiPart = false) {
    return this.httpRequest("POST", `${apiUrl}`, data, { multiPart });
  }
  //Get all form-data
  getAllFormsData(apiUrl) {
    return this.httpRequest("GET", `puc/get-form-details/${apiUrl}`, null);
  }
  getAllDisplayWallFormsData(apiUrl) {
    return this.httpRequest("GET", `display-wall/details/${apiUrl}`, null);
  }

  // Get city/state based on pincode
  getLocations(pinCode) {
    return this.httpRequest("GET", `generic/pincode/get-all?searchTerm=${pinCode}`, null, {
      location: true
    });
  }
  //  API For Get Role Data
  getRoleData(apiUrl) {
    return this.httpRequest("GET", `${apiUrl}`, null);
  }

  //  API To Make Get Request
  getRequest(apiUrl) {
    return this.httpRequest("GET", `${apiUrl}`, null);
  }

  //  API To Make Post Request
  postRequest(data, apiUrl) {
    return this.httpRequest("POST", apiUrl, data);
  }

  //  API To Make Put Request
  putRequest(data, apiUrl) {
    return this.httpRequest("PUT", apiUrl, data);
  }

  // API For Multiple Delete
  postDelete(data, apiUrl) {
    return this.httpRequest("POST", apiUrl, data);
  }
  // API For Post data
  postCreateUser(data, apiUrl) {
    return this.httpRequest("POST", apiUrl, data);
  }
  // API For Single data Update
  patchUser(data, apiUrl) {
    return this.httpRequest("PATCH", apiUrl, data);
  }

  // API For Update user
  putUser(data, apiUrl) {
    return this.httpRequest("PUT", apiUrl, data);
  }
  // API For Update single item item / template
  updateItem(data, apiUrl) {
    return this.httpRequest("PUT", apiUrl, data);
  }

  // API For Post data item / template
  postCreateItem(data, apiUrl) {
    return this.httpRequest("POST", apiUrl, data);
  }
  // API For delete data
  delete(apiUrl) {
    return this.httpRequest("Delete", apiUrl);
  }

  //Get dummy data
  getDummyData() {
    return this.httpRequest("GET", `https://jsonplaceholder.typicode.com/todos`, null);
  }

  // Get all instruments
  getAllInstruments() {
    return this.httpRequest("GET", `${quotesPrefix}/investor/instrument`, null);
  }

  // API For Admin login
  adminLogin(data) {
    return this.httpRequest("POST", `generic/users/login-user`, data);
  }

  // All request single page view data
  allRequestSinglePage(id) {
    return this.httpRequest("GET", `admin/requests/get-request-details/${id}`);
  }
  // Display Wall single page view data
  displayWallSinglePage(id) {
    return this.httpRequest("GET", `/admin/display-wall/get-wall-by-id/${id}`);
  }

  // location check single page view data
  locationSinglePage(id) {
    return this.httpRequest("GET", `admin/location/get-single-location-request/${id}`);
  }

  // location check single page view data
  locationExceptionSinglePage(id) {
    return this.httpRequest("GET", `admin/exception-location/get-single-exception-request/${id}`);
  }

  // doc verification single page view data
  docSinglePage(id) {
    return this.httpRequest("GET", `admin/files/get-single-file-request/${id}`);
  }

    // get notification data
    getNotificationData() {
      return this.httpRequest("GET", `/notifications/get-all-notifications?filterTerm={"status":"unread"}`,null);
    }

    // update notification status
    updateNotificationStatus(id) {
      return this.httpRequest("PUT", `notifications/update-notifications/${id}`);
    }

  // Reminder API for all request reminder request
  sendReminder(id) {
    return this.httpRequest("POST", `admin/payment/reminder/${id}`);
  }

  // this function used to raise exception
  raiseException(id, data){
    return this.httpRequest("POST", `admin/deposit-check/exception-status/${id}`, data);
  }

  //All request update status
  allrequestUpdateStatus(data) {
    return this.httpRequest("POST", `admin/requests/add-personal-puc-status`, data);
  }
  //Payment management update status
  paymentUpdateStatus(data) {
    return this.httpRequest("PUT", `admin/payment/status-furniture-payment`, data, {
      multiPart: true
    });
  }

  //Location check update status
  locationCheckUpdateStatus(data) {
    return this.httpRequest("POST", `admin/location/add-location-status`, data);
  }
  //Location check update status
  locationExceptionCheckUpdateStatus(data) {
    return this.httpRequest(
      "POST",
      `admin/exception-location/update-exception-location-status`,
      data
    );
  }

  //Single File remark status
  singleFileUpdateStatus(data) {
    return this.httpRequest("PUT", `admin/files/add-single-file-status`, data);
  }

  //All Files remark status
  allfilesUpdateStatus(data) {
    return this.httpRequest("PUT", `admin/files/add-all-files-status`, data);
  }

  //Doc verification update status
  docVerificationUpdateStatus(data) {
    return this.httpRequest("POST", `admin/files/add-files-status`, data);
  }
  // forgot password : Post mobile number
  forgotPassword(data) {
    return this.httpRequest("POST", `generic/users/forget-password`, data);
  }
  //forgot password : Post mobile number & OTP
  validateOTP(data) {
    return this.httpRequest("POST", `generic/users/validate-otp`, data);
  }
  // forgot password : Post mobile number & OTP
  changepassword(id, data) {
    return this.httpRequest("POST", `generic/users/change-password/${id}`, data);
  }

 // update assign depot
 updateAssignDepot(id, data){
  return this.httpRequest("POST", `/admin/deposit-check/allocate-depots/${id}`, data);
}

  // Get assign depot
  getAssignDepot(id) {
    return this.httpRequest("GET", `admin/deposit-check/get-puc-allocated-depots/${id}`);
  }

  // update dealer response
  updateDealerResponse(data) {
    return this.httpRequest("PUT", `${quotesPrefix}/dealer/response`, data);
  }

  // update Instrument active/deactive
  activeDeactiveInstrument(data) {
    return this.httpRequest("PATCH", `${quotesPrefix}/admin/instrument/${data.id}`, data.data);
  }

  //remove instrument association
  removeInstrumentAssociation(data) {
    return this.httpRequest(
      "DELETE",
      `${quotesPrefix}/${data.type}/associateInstrument`,
      data.payload
    );
  }

  // Get roylaty/technical achiever detail based on id
  getRoyaltyTechnicalAchieverDetails(id, type) {
    return this.httpRequest("GET", `generic/users/royalty-technical/${id}/${type}`, null);
  }
}
